import Vue from 'vue'
import Router from 'vue-router'

import {
  ProjectPage,
  AuthPage,
  AdminProjectPage,
  MainPage,
  AdminUserPage,
} from '../components/Pages';
import asyncQuery from "../asyncQuery";

Vue.use(Router);

const isAdmin = function (to, from, next) {
  asyncQuery({
    url: '/auth/status',
    handleSuccess: json => {
      json.data.isAdmin
        ? next()
        : next(false)
    },
  });
};

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage,
    },
    {
      path: '/auth',
      name: 'AuthPage',
      component: AuthPage,
    },
    {
      path: '/project/:name',
      name: 'ProjectPage',
      component: ProjectPage,
    },
    {
      path: '/project/:name/:concept',
      name: 'ProjectPageConcept',
      component: ProjectPage,
    },
    {
      path: '/admin_project',
      name: 'AdminProjectPage',
      component: AdminProjectPage,
      beforeEnter: isAdmin,
    },
    {
      path: '/admin_user',
      name: 'AdminUserPage',
      component: AdminUserPage,
      beforeEnter: isAdmin,
    },
  ]
})
